// extracted by css-extract-rspack-plugin
export default {"modalContentInner":"modal-content-inner--UNg8wZ1vA8L6tI_D"};